// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitcher_container__Tg1W2","icon":"LanguageSwitcher_icon__TmMwt"};